
exports.getRandomColor = () => {
    const letters = '56789ABCDEF';
    let color = '#';
    for (let i = 0; i < 3; i++) {
        color += letters[Math.floor(Math.random() * 11)];
    }
    return color;
};